import type { Session } from "@supabase/supabase-js";

export const maximumSessionAgeMs = 8 * 60 * 60 * 1000;
export const inactivityTimeoutMs = 30 * 60 * 1000;

const activityKey = (userId: string) => `jarasna-crm-last-activity:${userId}`;

export const sessionStartedAt = (session: Session) => {
  const parsed = Date.parse(session.user.last_sign_in_at ?? "");
  return Number.isFinite(parsed) ? parsed : (session.expires_at ?? Math.floor(Date.now() / 1000) + 3600) * 1000 - 60 * 60 * 1000;
};

export const readLastActivity = (session: Session, storage: Storage) => {
  const parsed = Number(storage.getItem(activityKey(session.user.id)));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : sessionStartedAt(session);
};

export const recordActivity = (session: Session, storage: Storage, now = Date.now()) => {
  storage.setItem(activityKey(session.user.id), String(now));
};

export const clearActivity = (session: Session, storage: Storage) => {
  storage.removeItem(activityKey(session.user.id));
};

export const isSessionExpired = (sessionStart: number, lastActivity: number, now = Date.now()) =>
  now - sessionStart >= maximumSessionAgeMs || now - lastActivity >= inactivityTimeoutMs;
